<section
  class="relative h-full touch-auto overflow-x-hidden overflow-y-auto pr-0.5"
  aria-label="Create support ticket"
>
  <button
    type="button"
    class="text-brand-text/40 hover:text-brand-text/80 absolute top-4 right-4 flex h-8 w-8 cursor-pointer items-center justify-center border-none bg-transparent transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1"
    (click)="closeDialog()"
    aria-label="Close dialog"
  >
    <mat-icon
      fontSet="material-icons-outlined"
      class="!h-[30px] !w-[30px] !text-[30px] leading-none"
      aria-hidden="true"
    >
      close
    </mat-icon>
  </button>
  <section
    class="hidden"
    aria-label="Select ticket type"
    [ngClass]="{
      '!block': !isTicketOptionSelected() && !isTicketSubmitted(),
    }"
  >
    @if (!isTicketOptionSelected()) {
      <div>
        @if (ticketFormGroup) {
          <form
            class="p-4 md:p-[25px]"
            [formGroup]="ticketFormGroup"
            [ngClass]="{ 'form-submit-attempt': formSubmitAttempted() }"
            autocomplete="off"
          >
            <h1>Create Ticket</h1>

            @if (
              (areServicesLoading$ | async) || (areInvoicesLoading$ | async)
            ) {
              <div class="my-4 animate-pulse" role="status">
                <div
                  class="mb-4 h-5 w-64 rounded bg-gray-200"
                  aria-hidden="true"
                ></div>
                <div
                  class="grid grid-cols-1 gap-3 md:grid-cols-2"
                  aria-hidden="true"
                >
                  @for (card of [1, 2, 3, 4]; track card) {
                    <div
                      class="rounded border border-neutral-200 bg-gray-50 p-4"
                    >
                      <div class="mb-2 h-8 w-8 rounded bg-gray-200"></div>
                      <div class="mb-2 h-4 w-3/4 rounded bg-gray-200"></div>
                      <div class="h-3 w-1/2 rounded bg-gray-200"></div>
                    </div>
                  }
                </div>
                <p class="font-lato text-brand-muted mt-4 text-sm">
                  Loading your options...
                </p>
              </div>
            }
            @if (
              !(areServicesLoading$ | async) && !(areInvoicesLoading$ | async)
            ) {
              <div class="relative h-full">
                <h2 class="mt-4 mb-3 text-base font-normal">
                  What's the subject matter of your ticket?
                </h2>
                <div
                  class="grid grid-cols-1 gap-3 md:grid-cols-2"
                  role="radiogroup"
                  aria-label="Ticket subject matter"
                  [attr.aria-describedby]="
                    inlineErrors.supportType ? 'ticket-subject-error' : null
                  "
                  [attr.aria-invalid]="!!inlineErrors.supportType"
                >
                  <ng-container *ngxPermissionsOnly="Permission.SERVICES">
                    @if ((services$ | async)?.length) {
                      <button
                        type="button"
                        class="comcast-radio-card"
                        [ngClass]="
                          ticketFormGroup.value.supportType ===
                          supportTypeLabel.SERVICE
                            ? 'border-blue-700 !bg-blue-700/5'
                            : 'border-gray-900/20'
                        "
                        role="radio"
                        [attr.aria-checked]="
                          ticketFormGroup.value.supportType ===
                          supportTypeLabel.SERVICE
                        "
                        aria-label="NOC - Outage or Performance, Service down or degraded"
                        (click)="
                          ticketFormGroup.controls.supportType.setValue(
                            supportTypeLabel.SERVICE
                          );
                          onSupportTypeChange({
                            value: supportTypeLabel.SERVICE,
                          })
                        "
                      >
                        @if (
                          ticketFormGroup.value.supportType ===
                          supportTypeLabel.SERVICE
                        ) {
                          <span
                            class="comcast-radio-card-check"
                            aria-hidden="true"
                          >
                            <mat-icon
                              fontSet="material-icons-outlined"
                              class="!flex !h-4 !w-4 !items-center !justify-center !text-base"
                              style="-webkit-text-stroke: 0.5px white"
                              aria-hidden="true"
                            >
                              check
                            </mat-icon>
                          </span>
                        }
                        <mat-icon
                          fontSet="material-icons-outlined"
                          class="mb-3 !h-8 !w-8 !text-3xl text-blue-700"
                          aria-hidden="true"
                        >
                          warning_amber
                        </mat-icon>
                        <span
                          class="text-lg leading-snug font-bold"
                          [ngClass]="
                            ticketFormGroup.value.supportType ===
                            supportTypeLabel.SERVICE
                              ? 'text-blue-700'
                              : 'text-brand-text'
                          "
                        >
                          NOC - Outage or Performance
                        </span>
                        <span
                          class="text-sm leading-snug"
                          [ngClass]="
                            ticketFormGroup.value.supportType ===
                            supportTypeLabel.SERVICE
                              ? 'text-blue-700'
                              : 'text-brand-text/75'
                          "
                        >
                          Service down or degraded
                        </span>
                      </button>
                    }
                  </ng-container>
                  <ng-container *ngxPermissionsOnly="Permission.BILLING_READ">
                    @if ((invoices$ | async)?.length) {
                      <button
                        type="button"
                        class="comcast-radio-card"
                        [ngClass]="
                          ticketFormGroup.value.supportType ===
                          supportTypeLabel.BILLING
                            ? 'border-blue-700 !bg-blue-700/5'
                            : 'border-gray-900/20'
                        "
                        role="radio"
                        [attr.aria-checked]="
                          ticketFormGroup.value.supportType ===
                          supportTypeLabel.BILLING
                        "
                        aria-label="Billing & Payment, Invoice or charge questions"
                        (click)="
                          ticketFormGroup.controls.supportType.setValue(
                            supportTypeLabel.BILLING
                          );
                          onSupportTypeChange({
                            value: supportTypeLabel.BILLING,
                          })
                        "
                      >
                        @if (
                          ticketFormGroup.value.supportType ===
                          supportTypeLabel.BILLING
                        ) {
                          <span
                            class="comcast-radio-card-check"
                            aria-hidden="true"
                          >
                            <mat-icon
                              fontSet="material-icons-outlined"
                              class="!flex !h-4 !w-4 !items-center !justify-center !text-base"
                              style="-webkit-text-stroke: 0.5px white"
                              aria-hidden="true"
                            >
                              check
                            </mat-icon>
                          </span>
                        }
                        <mat-icon
                          fontSet="material-icons-outlined"
                          class="mb-3 !h-8 !w-8 !text-3xl text-blue-700"
                          aria-hidden="true"
                        >
                          receipt_long
                        </mat-icon>
                        <span
                          class="text-lg leading-snug font-bold"
                          [ngClass]="
                            ticketFormGroup.value.supportType ===
                            supportTypeLabel.BILLING
                              ? 'text-blue-700'
                              : 'text-brand-text'
                          "
                        >
                          Billing & Payment
                        </span>
                        <span
                          class="text-sm leading-snug"
                          [ngClass]="
                            ticketFormGroup.value.supportType ===
                            supportTypeLabel.BILLING
                              ? 'text-blue-700'
                              : 'text-brand-text/75'
                          "
                        >
                          Invoice or charge questions
                        </span>
                      </button>
                    }
                  </ng-container>
                  @if ((services$ | async)?.length) {
                    <button
                      type="button"
                      class="comcast-radio-card"
                      [ngClass]="
                        ticketFormGroup.value.supportType ===
                        supportTypeLabel.TOB
                          ? 'border-blue-700 !bg-blue-700/5'
                          : 'border-gray-900/20'
                      "
                      role="radio"
                      [attr.aria-checked]="
                        ticketFormGroup.value.supportType ===
                        supportTypeLabel.TOB
                      "
                      aria-label="Service Changes & Transfers, Upgrades & downgrades"
                      (click)="
                        selectedSupportTile.set(supportTypeLabel.TOB);
                        ticketFormGroup.controls.supportType.setValue(
                          supportTypeLabel.TOB
                        );
                        onSupportTypeChange({ value: supportTypeLabel.TOB })
                      "
                    >
                      @if (
                        ticketFormGroup.value.supportType ===
                        supportTypeLabel.TOB
                      ) {
                        <span
                          class="comcast-radio-card-check"
                          aria-hidden="true"
                        >
                          <mat-icon
                            fontSet="material-icons-outlined"
                            class="!flex !h-4 !w-4 !items-center !justify-center !text-base"
                            style="-webkit-text-stroke: 0.5px white"
                            aria-hidden="true"
                          >
                            check
                          </mat-icon>
                        </span>
                      }
                      <mat-icon
                        fontSet="material-icons-outlined"
                        class="mb-3 !h-8 !w-8 !text-3xl text-blue-700"
                        aria-hidden="true"
                      >
                        check_circle_outline
                      </mat-icon>
                      <span
                        class="text-lg leading-snug font-bold"
                        [ngClass]="
                          ticketFormGroup.value.supportType ===
                          supportTypeLabel.TOB
                            ? 'text-blue-700'
                            : 'text-brand-text'
                        "
                      >
                        Service Changes & Transfers
                      </span>
                      <span
                        class="text-sm leading-snug"
                        [ngClass]="
                          ticketFormGroup.value.supportType ===
                          supportTypeLabel.TOB
                            ? 'text-blue-700'
                            : 'text-brand-text/75'
                        "
                      >
                        Upgrades & downgrades
                      </span>
                    </button>
                  }
                  <button
                    type="button"
                    class="comcast-radio-card"
                    [ngClass]="{
                      'border-blue-700':
                        selectedSupportTile() === generalInquirySupportTile,
                      '!bg-blue-700/5':
                        selectedSupportTile() === generalInquirySupportTile,
                      'border-gray-900/20':
                        selectedSupportTile() !== generalInquirySupportTile,
                      'md:col-span-2': (hasNoServicesOrInvoices$ | async),
                    }"
                    role="radio"
                    [attr.aria-checked]="
                      selectedSupportTile() === generalInquirySupportTile
                    "
                    aria-label="General Inquiry, Other questions & requests"
                    (click)="
                      selectedSupportTile.set(generalInquirySupportTile);
                      ticketFormGroup.controls.supportType.setValue(
                        supportTypeLabel.CARE
                      );
                      onSupportTypeChange({ value: supportTypeLabel.CARE })
                    "
                  >
                    @if (selectedSupportTile() === generalInquirySupportTile) {
                      <span class="comcast-radio-card-check" aria-hidden="true">
                        <mat-icon
                          fontSet="material-icons-outlined"
                          class="!flex !h-4 !w-4 !items-center !justify-center !text-base"
                          style="-webkit-text-stroke: 0.5px white"
                          aria-hidden="true"
                        >
                          check
                        </mat-icon>
                      </span>
                    }
                    <mat-icon
                      fontSet="material-icons-outlined"
                      class="mb-3 !h-8 !w-8 !text-3xl text-blue-700"
                      aria-hidden="true"
                    >
                      info
                    </mat-icon>
                    <span
                      class="text-lg leading-snug font-bold"
                      [ngClass]="
                        selectedSupportTile() === generalInquirySupportTile
                          ? 'text-blue-700'
                          : 'text-brand-text'
                      "
                    >
                      General Inquiry
                    </span>
                    <span
                      class="text-sm leading-snug"
                      [ngClass]="
                        selectedSupportTile() === generalInquirySupportTile
                          ? 'text-blue-700'
                          : 'text-brand-text/75'
                      "
                    >
                      Other questions & requests
                    </span>
                  </button>
                </div>

                @if (
                  ticketFormGroup.value.supportType === supportTypeLabel.SERVICE
                ) {
                  <div
                    class="mt-4 flex items-start gap-3 rounded-sm border border-blue-700/20 bg-blue-700/5 px-4 py-3 text-sm leading-relaxed"
                    role="note"
                    aria-live="polite"
                  >
                    <mat-icon
                      fontSet="material-icons-outlined"
                      class="!flex !h-5 !w-5 shrink-0 !items-center !justify-center !text-xl text-blue-700"
                      aria-hidden="true"
                    >
                      info
                    </mat-icon>
                    <span>
                      NOC tickets are routed directly to the Network Operations
                      Center and treated as high priority.
                    </span>
                  </div>
                }

                <ng-container
                  *ngxPermissionsOnly="[Permission.ORDERS, Permission.SERVICES]"
                >
                  @if ((services$ | async)?.length) {
                    <div
                      class="text-brand-text/70 mt-3 flex flex-wrap items-center gap-2 text-sm"
                    >
                      <span>Need to end an active service?</span>
                      <button
                        type="button"
                        class="inline-flex items-center gap-1 border-0 bg-transparent p-0 font-semibold text-blue-700 underline underline-offset-4 hover:text-blue-700/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-2"
                        (click)="
                          selectedSupportTile.set(supportTypeLabel.DISCONNECT);
                          ticketFormGroup.controls.supportType.setValue(
                            supportTypeLabel.DISCONNECT
                          );
                          onSupportTypeChange({
                            value: supportTypeLabel.DISCONNECT,
                          });
                          makeTicketSelection()
                        "
                      >
                        Disconnect a service
                        <mat-icon
                          fontSet="material-icons-outlined"
                          class="!flex !h-4 !w-4 !items-center !justify-center !text-base"
                          aria-hidden="true"
                        >
                          arrow_forward
                        </mat-icon>
                      </button>
                    </div>
                  }
                </ng-container>

                @if (inlineErrors.supportType) {
                  <div
                    id="ticket-subject-error"
                    class="comcast-warning-alert mt-3"
                    role="alert"
                  >
                    <mat-icon
                      fontSet="material-icons-outlined"
                      class="!flex !h-5 !w-5 !items-center !justify-center !text-xl"
                      aria-hidden="true"
                    >
                      info
                    </mat-icon>
                    <span>{{ inlineErrors.supportType }}</span>
                  </div>
                }

                <div
                  class="sticky bottom-0 -mx-4 mt-5 border-t border-gray-100 bg-white px-4 pt-3 pb-4 md:-mx-[25px] md:px-[25px]"
                >
                  <button
                    type="button"
                    class="btn-primary flex w-full items-center justify-center gap-2"
                    (click)="makeTicketSelection()"
                  >
                    Continue
                    <mat-icon
                      fontSet="material-icons-outlined"
                      class="!flex !h-5 !w-5 !items-center !justify-center !text-xl"
                      aria-hidden="true"
                    >
                      arrow_forward
                    </mat-icon>
                  </button>
                </div>
              </div>
            }
          </form>
        }
      </div>
    }
  </section>

  <section
    class="hidden p-4 md:p-[25px]"
    aria-label="Ticket details"
    [ngClass]="{
      '!block': isTicketOptionSelected() && !isTicketSubmitted(),
    }"
  >
    <button
      type="button"
      class="mb-5 flex cursor-pointer items-center gap-1 border-none bg-transparent p-0 text-base font-semibold text-blue-700 transition-colors outline-none hover:text-blue-700/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1"
      aria-label="Back to ticket type selection"
      (click)="goBack()"
    >
      <mat-icon
        fontSet="material-icons-outlined"
        class="!flex !h-6 !w-6 !items-center !justify-center !text-base"
        aria-hidden="true"
      >
        arrow_back
      </mat-icon>
      Back
    </button>
    @if (
      isTicketOptionSelected() &&
      ticketFormGroup.value.supportType === supportTypeLabel.SERVICE
    ) {
      <app-ticket-noc
        [services]="services$ | async"
        [selectedServiceId]="selectedServiceId"
        [primaryReporters]="contacts$ | async"
        [submissionError]="hasSubmissionError()"
        [isSubmitting]="isSubmitting()"
        (submitNocForm)="submitNocForm($event)"
        [errorMessage]="errorMessage()"
        [hideCustomerTicketNumber]="hideCustomerTicketNumber$ | async"
      ></app-ticket-noc>
    }
    @if (
      isTicketOptionSelected() &&
      ticketFormGroup.value.supportType === supportTypeLabel.BILLING
    ) {
      <app-ticket-billing
        [invoices]="invoices$ | async"
        [isLoading]="areInvoicesLoading$ | async"
        [submissionError]="hasSubmissionError()"
        [isSubmitting]="isSubmitting()"
        (submitBillForm)="submitBillForm($event)"
        [errorMessage]="errorMessage()"
      ></app-ticket-billing>
    }
    @if (
      isTicketOptionSelected() &&
      ticketFormGroup.value.supportType === supportTypeLabel.DISCONNECT
    ) {
      <app-ticket-disconnect
        [services]="services$ | async"
        [selectedServiceId]="selectedServiceId"
        [primaryReporters]="contacts$ | async"
        [disconnectReasons]="disconnectReasons$ | async"
        [submissionError]="hasSubmissionError()"
        [errorMessage]="errorMessage()"
        [isSubmitting]="isSubmitting()"
        (submitForm)="submitOrderForm($event)"
      ></app-ticket-disconnect>
    }
    @if (
      isTicketOptionSelected() &&
      ticketFormGroup.value.supportType === supportTypeLabel.CARE
    ) {
      <app-ticket-care
        [services]="services$ | async"
        [selectedServiceId]="selectedServiceId"
        [isLoading]="areServicesLoading$ | async"
        [hasLoaded]="areServicesLoaded$ | async"
        [primaryReporters]="contacts$ | async"
        [submissionError]="hasSubmissionError()"
        [errorMessage]="errorMessage()"
        [isSubmitting]="isSubmitting()"
        (submitCareForm)="submitCareForm($event)"
      ></app-ticket-care>
    }
    @if (
      isTicketOptionSelected() &&
      ticketFormGroup.value.supportType === supportTypeLabel.TOB
    ) {
      <app-ticket-tob
        [services]="services$ | async"
        [selectedServiceId]="selectedServiceId"
        [primaryReporters]="contacts$ | async"
        [submissionError]="hasSubmissionError()"
        [errorMessage]="errorMessage()"
        [isSubmitting]="isSubmitting()"
        (submitForm)="submitOrderForm($event)"
        (submitCareForm)="submitCareForm($event)"
      ></app-ticket-tob>
    }
  </section>

  @if (isTicketSubmitted()) {
    <section class="flex h-full items-center" aria-label="Ticket submitted">
      <app-ticket-success
        (closed)="closeDialog()"
        [order]="createdOrder()"
      ></app-ticket-success>
    </section>
  }
</section>
